// The application is already French. Browser auto-translation replaces React's
// text nodes with <font> elements and can break removeChild during UI updates.
// Also apply to an older cached HTML shell before mounting a newer JS bundle.
export const protectDisplayLanguage = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = 'fr';
  document.documentElement.setAttribute('translate', 'no');
  document.documentElement.classList.add('notranslate');
  const root = document.getElementById('root');
  if (root) {
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
  }
};

protectDisplayLanguage();